import { render } from "./InlineSize.vue?vue&type=template&id=38a9cbe9&scoped=true&ts=true"
import script from "./InlineSize.vue?vue&type=script&lang=ts"
export * from "./InlineSize.vue?vue&type=script&lang=ts"

import "./InlineSize.vue?vue&type=style&index=0&id=38a9cbe9&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a9cbe9"]])

export default __exports__